(function(){
  var gal=document.querySelector('[data-gal]');
  var lb=document.querySelector('[data-lb]'),lbi=0;
  function thumbs(i){document.querySelectorAll('[data-thumb-id]').forEach(function(b,n){b.setAttribute('aria-current',n===i);});var c=document.querySelector('[data-gal-count]');if(c&&gal)c.textContent=(i+1)+' / '+gal.children.length;}
  function go(id,smooth){if(!gal||!id)return;var s=gal.querySelector('[data-img-id="'+id+'"]');if(s)gal.scrollTo({left:s.offsetLeft,behavior:smooth?'smooth':'auto'});}
  function lbShow(i){if(!gal||!lb)return;var s=gal.children;lbi=(i+s.length)%s.length;var im=lb.querySelector('[data-lb-img]');var src=s[lbi].querySelector('img');im.src=s[lbi].dataset.zoom;im.alt=src?src.alt:'';var c=lb.querySelector('[data-lb-count]');if(c)c.textContent=(lbi+1)+' / '+s.length;}
  function lbClose(){if(!lb)return;if(lb.close)lb.close();else lb.removeAttribute('open');if(gal&&gal.children[lbi])gal.scrollTo({left:gal.children[lbi].offsetLeft,behavior:'auto'});}
  if(gal){
    var t;gal.addEventListener('scroll',function(){clearTimeout(t);t=setTimeout(function(){thumbs(Math.round(gal.scrollLeft/gal.clientWidth));},80);});
    go(gal.dataset.startId,false);
    thumbs(Math.round(gal.scrollLeft/gal.clientWidth));
  }
  document.addEventListener('change',function(e){
    var t=e.target;
    if(t.matches('[data-sort]')){var u=new URL(location.href);u.searchParams.set('sort_by',t.value);location.href=u.toString();}
    if(t.matches('[data-variant]')){
      var o=t.tagName==='SELECT'?t.options[t.selectedIndex]:t;
      document.querySelectorAll('[data-price]').forEach(function(el){el.innerHTML=o.dataset.price;});
      var ok=o.dataset.available==='true';
      document.querySelectorAll('[data-buy]').forEach(function(b){b.disabled=!ok;b.textContent=ok?'Adicionar ao carrinho':'Esgotado';});
      var n=document.querySelector('[data-vname]');if(n)n.textContent=o.dataset.title||'';
      go(o.dataset.imageId,true);
      var u2=new URL(location.href);u2.searchParams.set('variant',o.value);history.replaceState(null,'',u2.toString());
    }
  });
  document.addEventListener('click',function(e){
    var th=e.target.closest('[data-thumb-id]');
    if(th)go(th.dataset.thumbId,true);
    var ar=e.target.closest('[data-gal-step]');
    if(ar&&gal)gal.scrollBy({left:gal.clientWidth*Number(ar.dataset.galStep),behavior:'smooth'});
    var sl=e.target.closest('.gal-slide');
    if(sl&&lb&&gal){lbShow(Array.prototype.indexOf.call(gal.children,sl));if(lb.showModal)lb.showModal();else lb.setAttribute('open','');}
    var st=e.target.closest('[data-lb-step]');
    if(st)lbShow(lbi+Number(st.dataset.lbStep));
    if(e.target.closest('[data-lb-close]')||e.target===lb)lbClose();
    if(e.target.closest('[data-stick-buy]')){var f=document.querySelector('[data-product-form]');if(f)f.requestSubmit?f.requestSubmit():f.submit();}
  });
  document.addEventListener('keydown',function(e){
    if(!lb||!lb.open)return;
    if(e.key==='ArrowLeft')lbShow(lbi-1);
    if(e.key==='ArrowRight')lbShow(lbi+1);
  });
  if(lb){
    lb.addEventListener('cancel',function(e){e.preventDefault();lbClose();});
    var sx=null;
    lb.addEventListener('touchstart',function(e){sx=e.touches[0].clientX;},{passive:true});
    lb.addEventListener('touchend',function(e){if(sx===null)return;var d=e.changedTouches[0].clientX-sx;sx=null;if(Math.abs(d)>50)lbShow(lbi+(d<0?1:-1));},{passive:true});
  }
})();
